<script>
  // Import of functions and functions elements
  import { Router, Link, Route, navigate } from "svelte-routing";
  import { onMount } from "svelte";

  // Importing application pages

  import LoginPage from "./pages/LoginPage.svelte";
  import Homepage from "../src/pages/HomePage.svelte";
  import ProfilePage from "./pages/Profile/UserPage.svelte";
  import ResetPassword from "./pages/RestPassword.svelte";
  import EventsCentral from "./pages/AdminPages/EventsList.svelte";
  import AttendeeList from "./pages/AdminPages/AttendeeList.svelte";
  import MeetingsList from "./pages/AdminPages/MeetingsList.svelte";
  import CoordinatorsList from "./pages/AdminPages/CoordinatorsSection.svelte";
  import EventPage from "./pages/EventPage.svelte";
  import Navbar from "./components/Navbar.svelte";
  import Footer from "./components/Footer.svelte";
  import AttendeesSocial from "./pages/AttendeesSocial.svelte";
  import Error from "./pages/404Error.svelte";
  import ChatCentral from "./components/Chat/ChatCentral.svelte";
  import DataPolls from "./pages/DataPolls.svelte";
  import ConfirmModal from "./components/Modals/ConfirmModal.svelte"
  import MeetsCentralControl from "./pages/MeetsCentralControl.svelte";

  //Auxiliary Variables
  let dataAnswer = false;
  let pathname

 //Logged-in session verification
  onMount(() => {
    pathname = window.location.pathname.split("/")[1];
    if ("pollanswers" === pathname) {
      dataAnswer = true
    }    
  }); 
</script>

<Router>
  {#if !dataAnswer} 
	<Navbar />
  {/if}
  <Route path="/" component={LoginPage} />
  <Route path="/resetPassword" component={ResetPassword} />
  <Route path="/pollanswers/:id/:pollTittle" component={DataPolls} />
  <!-- Protected routes -->
  <Route path="/home" component={Homepage} />
  <Route path="/eventhub" component={EventsCentral} />
  <Route path="/attendeeslist" component={AttendeeList} />
  <Route path="/meetingslis" component={MeetingsList} />
  <Route path="/coordinatorslist" component={CoordinatorsList} />
  <Route path="/myProfile" component={ProfilePage} />
  <Route path="/mymeets/:id" component={MeetsCentralControl} />
  <Route path="/socialattendees" component={AttendeesSocial} />
  <Route path="/socialattendees/:id" component={AttendeesSocial} />
  <Route path="/myChats" component={ChatCentral} />
  <Route path="/myChats/:id" component={ChatCentral} />
  <Route path="/event/:id/:tittle" component={EventPage} />
  <Route path="*" component={Error} />
  <!-- {#if $isConfirmModalOn}
    <ConfirmModal/>
  {/if} -->
  {#if !dataAnswer}
	<Footer /> 
  {/if}
</Router>
